<template>
    <Fragment>
        <template v-if="!mainAddress.postal_code">
            <p>Seu endereço está incompleto. Complete os dados para continuar.</p>
        </template>
        <template v-else>
        <AppSummary
            title_summary="Entrega"
            :collapses="collapses"
            v-if="showDeliveryMethods"
        >
            <template #order-shipping-collapse>
                <clip-loader :loading="loadingCalculate" :color="$colorLoading">
                </clip-loader>
                <!-- <template v-if="shippings.correio && !loadingCalculate">
                <div
                    v-for="(shipping, key) in shippings.correio"
                    :key="key"
                    class="form-group"
                >
                    <template v-if="shipping.error === '0'">
                        <div class="radio-group " >
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        :value="shipping"
                                        v-model="metodoenvio"
                                        @change="updateShipping(shipping)"
                                        :id="'shipping'+key+1"
                                    >
                                </span>
                                <span class="forma-conteiner" style="font-size:12px">
                                        {{ shipping.price > 0 ? currency.money(shipping.price) : null }}
                                    <strong>{{ prazoEntrega(shipping.prazoEntrega) }} </strong>
                                    {{ shipping.type  }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </template> -->

                <template v-if="shippingMethods && !loadingCalculate">
                    <div
                        v-for="(shipping, key) in shippingMethods"
                        :key="key"
                        class="form-group"
                    >
                        <template v-if="shipping.error === '0'">
                            <div
                                class="radio-group "
                                @click="updateShipping(shipping)"
                                style="margin-bottom: 0;"
                            >
                                <div class="radio-heading">
                                    <span class="radio-conteiner">
                                        <input
                                            type="radio"
                                            :value="shipping"
                                            @change="updateShipping(shipping)"
                                            :id="'shipping' + key + 1"
                                            :checked="setChecked(shipping)"
                                        />
                                        <!-- v-model="metodoenvio" -->
                                    </span>
                                    <span
                                        class="forma-conteiner"
                                        style="font-size:12px"
                                    >
                                        {{ shipping.type }}

                                            {{
                                                prazoEntrega(
                                                    shipping.prazoEntrega
                                                )
                                            }}
                                        <strong>
                                            {{
                                            +shipping.price > 0 &&
                                            shipping.type != "RETIRAR NA LOJA"
                                                ? currency.money(shipping.price)
                                                : null
                                            }}
                                        </strong>
                                    </span>
                                </div>
                            </div>
                            <div style="padding: 5px 10px; border-radius: 4px; font-size: 12px;"
                                class="collapse"
                                :id="'shipping'+shipping.id"
                                :key="shipping.id+120"
                                :class="['content-payment', shipping && shipping.description ? 'content-payment-active show' : null]">
                                <p style="margin-bottom: 0;">{{ shipping.description }}</p>
                            </div>
                        </template>
                    </div>
                </template>
                <template v-if="(shippingMethods && !loadingCalculate) && biggerAvailability != 0">
                    <small>Item com prazo para disponibilidade no carrinho: <strong>+{{ biggerAvailability > 1 ? biggerAvailability + 'dias' : biggerAvailability + 'dia' }}</strong> para entrega. </small>
                </template>
                <template v-if="shippings.frenet && !loadingCalculate">
                    <div
                        v-for="(shipping, key) in shippings.frenet"
                        :key="key"
                        class="form-group"
                    >
                        <template v-if="!shipping.Error">
                            <div
                                class="radio-group "
                                @click="updateShipping(shipping)"
                            >
                                <div class="radio-heading">
                                    <span class="radio-conteiner">
                                        <input
                                            type="radio"
                                            :value="shipping"
                                            name="shipping_frenet"
                                            @change="updateShipping(shipping)"
                                            :id="'shipping_frenet' + key + 1"
                                            :checked="setChecked(shipping)"
                                        />
                                        <!-- v-model="metodoenvio" -->
                                    </span>
                                    <span
                                        class="forma-conteiner"
                                        style="font-size:12px"
                                    >
                                    {{ shipping.ServiceDescription }}

                                    {{ prazoEntrega(shipping.DeliveryTime)}}
                                        <strong>
                                            {{
                                            shipping.ShippingPrice > 0
                                                ? currency.money(
                                                      shipping.ShippingPrice
                                                  )
                                                : null
                                        }}
                                        </strong>

                                    </span>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>

            </template>
            <template
                #delivery-times-shipping-collapse
                v-if="showDeliveryTimes"
            >
                <div
                    class="delivery-times-calendar"
                    @click="handleOpenModalCalendar"
                >
                    <input type="text" :value="deliveryTimeValue" readonly />
                    <i class="icon-calendar"></i>
                </div>
                <ModalCalendar :modal_id="modal_calendar">
                    <CalendarDeliveryTime
                        :modal_id="modal_calendar"
                        :active_date="deliveryTime"
                        :shipping_company_id.sync="shipping_company_id"
                        :rule_id.sync="rule_id"
                        :delivery_time.sync="delivery_time"
                        @handleSelectDatetime="handleSelectDatetime"
                        @openModalDeliveryTime="openModalDeliveryTime"
                    />
                </ModalCalendar>
                <ModalCalendar :modal_id="modal_times">
                    <HoraryDeliveryTime
                        :modal_id="modal_times"
                        :delivery_times="delivery_times"
                        @handleSelectTime="handleSelectTime"
                    />
                </ModalCalendar>
            </template>

        </AppSummary>
        </template>
    </Fragment>
</template>

<script>
import AppSummary from "../AppSummary";
import TableMiniCart from "../TableMiniCart";
import Currency from "../../helpers/parseCurrency";
import { mapActions, mapGetters, mapState } from "vuex";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { Fragment } from "vue-fragment";
import CalendarDeliveryTime from "../CalendarDeliveryTime";
import ModalCalendar from "../ModalCalendar";
import HoraryDeliveryTime from "../HoraryDeliveryTime";
import { swall } from "../../services/sweetAlert";
import Permissions from "../../services/Permissions";
import { Modules } from "../../enums/Modules";
import { ThemeProvider } from "vue-styled-components";

export default {
    name: "ShippingCheckout",
    components: {
        AppSummary,
        TableMiniCart,
        "clip-loader": ClipLoader,
        Fragment,
        CalendarDeliveryTime,
        ModalCalendar,
        HoraryDeliveryTime
    },
    props: {
        mainAddress: {default: null},
        novoAddress: {default: null}
    },
    data() {
        return {
            currency: Currency,
            metodoenvio: null,
            shippingMethods: [],
            collapses: [
                {
                    title: "Escolha sua entrega",
                    id: "order-shipping-collapse",
                    collapsed: true
                },
                {
                    title: "Escolha seu horário de entrega",
                    id: "delivery-times-shipping-collapse",
                    collapsed: true
                }
            ],
            modal_times: "modal_times_delivery",
            modal_calendar: "modal_calendar_delivery",
            delivery_times: [],
            delivery_time: null,
            biggerAvailability: 0
        };
    },
    created() {
        // this.getSessionDeliveryTime();
    },
    async mounted() {
        await this.ActionGetAllShippingCalculation();
        this.ActionGetShippingMethod();
    },
    methods: {
        ...mapActions("cart", ["ActionGetItemsCart", "ActionSetItemsCart"]),
        ...mapActions("shipping", [
            "ActionSetShippingMethod",
            "ActionSetShippingMethodState",
            "ActionGetAllShippingCalculation",
            "ActionGetShippingMethod"
        ]),
        ...mapActions("deliveryTimes", [
            "setOpenCalendar",
            "ActionSetSessionDeliveryTime",
            "ActionGetSessionDeliveryTime"
        ]),
        ...mapActions("payment", ["ActionSetObservacao"]),
        getSessionDeliveryTime() {
            this.ActionGetSessionDeliveryTime().catch(error =>
                swall(error?.msg ?? error?.message ?? error)
            );
        },
        handleOpenModalCalendar() {
            if (!this.rule_id) {
                swall("Selecione uma entrega!", true);
                return;
            }
            this.setOpenCalendar(true);
            this.$root.showModalApp(this.modal_calendar);
        },
        handleSelectTime(delivery_time) {
            this.delivery_time = delivery_time;
        },
        openModalDeliveryTime(delivery_times) {
            if (!delivery_times) {
                return;
            }
            this.delivery_times = delivery_times.map(dt => {
                if (dt.id == this.deliveryTime?.delivery_time_id) {
                    dt.checked = true;
                }
                return dt;
            });
            this.$root.showModalApp(this.modal_times);
        },
        async setSessionDeliveryTime(delivery_time) {
            await this.ActionSetSessionDeliveryTime(delivery_time)
                .then(() => this.getSessionDeliveryTime())
                .catch(error => swall(error?.msg ?? error?.message ?? error));
        },
        handleSelectDatetime(date, delivery_time) {
            this.setSessionDeliveryTime({ ...date, ...delivery_time });
        },
        prazoEntrega(prazo) {
            if (prazo === null || prazo == 0) {
                return;
            }
            prazo = +prazo + this.getBiggerAvailabilityInCart;
            if (prazo > 1) {
                return prazo + " dias";
            }
            return prazo + " dia";
        },
        async updateShipping(method) {
            try {
                if (method?.msgErro == "") {
                    method.msgErro = null;
                }
                if (method?.Msg == "") {
                    method.Msg = null;
                }
                await this.ActionSetShippingMethod({ shippingMethod: method });
                if(this.googleAds?.id != null) {
                    gtag('event', 'add_shipping_info', {
                        'pageTitle': this.company.nome_fantasia,
                        'pageCategory': 'Finalização de Pedido - Fretes',
                        'ecommerce': {
                            'currency': 'BRL',
                            'value': this.shippingMethod.price,
                            'shipping_tier': this.shippingMethod.type,
                            'products' : this.itemsCart.list.map(item => ({
                                'id' : item.api_cod_original,
                                'sku' : item.api_cod_original,
                                'name': item.pro_name_site,
                                'price': item.pro_price_site,
                                'brand': item.brand_name ?? "",
                                'discount' : item.percentage_discount,
                                'quantity' : Number(item.qtd_cart),
                                'variant': item.items_grid_abbreviaton ?? item.grid_grou_column_value + item.grid_grou_row_value
                            }))
                        },
                    });
                }
                if (Permissions.checkModule(Modules.HORARIOS_DE_ENTREGA)) {
                    await this.setSessionDeliveryTime(null);
                }
                if (this.workWithOrder) {
                    this.handleOpenModalCalendar();
                }
            } catch (error) {
                alert(error);
            }
        },
        setChecked(s) {
            if (!this.shippingMethod) {
                return false;
            }
            if(this.shippingMethod.ServiceCode) {
                return (
                s.id == this.shippingMethod.ServiceCode &&
                s.prazoEntrega == this.shippingMethod.OriginalDeliveryTime &&
                s.price == this.shippingMethod.ShippingPrice &&
                s.rule_id == this.shippingMethod.CarrierCode &&
                s.shipping_company_id == this.shippingMethod.ServiceCode &&
                s.type == this.shippingMethod.ServiceDescription
                )
            }
            else return (
                s.correio == this.shippingMethod.correio &&
                s.id == this.shippingMethod.id &&
                s.prazoEntrega == this.shippingMethod.prazoEntrega &&
                s.price == this.shippingMethod.price &&
                s.rule_id == this.shippingMethod.rule_id &&
                s.shipping_company_id ==
                    this.shippingMethod.shipping_company_id &&
                s.type == this.shippingMethod.type
            );
        }
    },
    watch: {
        async shippings() {
            this.metodoenvio = null;
            this.$set(this, "shippingMethods", []);
            await this.ActionSetShippingMethodState(null);
            let arr = [
                ...this.getCorreios,
                ...this.getRodonaves,
                ...this.getFflipFretes,
                ...this.getMelhorEnvio,
                ...this.getJadlog,
                ...this.getAcExpress,
                ...this.getAceville,
                ...this.getBraspress,
                ...this.getBauer,
                ...this.getExpressoSaoMiguel,
                ...this.getZanotelli,
                ...this.getTNT,
                ...this.getTodoBrasil,
                ...this.getAcevilleTdaTde,
                ...this.getAzurelog,
                ...this.getEbTrans,
                ...this.getRodovitor,
                ...this.getAgex,
                ...this.getFariasFaz,
                ...this.getScLogistica,
                ...this.getAlfa,
                ...this.getAtiva,
                ...this.getTotalExpress
            ];
            arr.map(
                el =>
                    !this.shippingMethods.filter(v => v.type === el.type)
                        .length && this.shippingMethods.push(el)
            );
        },
        itemsCart(data) {
            if (!data) {
                return;
            }
            this.metodoenvio = data.shippingMethod;
            this.ActionSetShippingMethodState(data.shippingMethod);
        }
    },
    computed: {
        ...mapState("cart", ["itemsCart"]),
        ...mapState("shipping", [
            "shippingMethod",
            "shippings",
            "loadingCalculate"
        ]),
        ...mapGetters("shipping", [
            "getCorreios",
            "getRodonaves",
            "getFflipFretes",
            "getMelhorEnvio",
            "getJadlog",
            "getAcExpress",
            "getAceville",
            "getBraspress",
            "getBauer",
            "getExpressoSaoMiguel",
            "getZanotelli",
            "getTNT",
            "getTodoBrasil",
            "getAcevilleTdaTde",
            "getAzurelog",
            "getEbTrans",
            "getRodovitor",
            "getAgex",
            "getFariasFaz",
            "getScLogistica",
            "getAlfa",
            "getAtiva",
            "getTotalExpress"
        ]),
        ...mapGetters("company", ["showDeliveryMethods", "workWithOrder"]),
        ...mapState("deliveryTimes", ["deliveryTime"]),
        ...mapState("payment", ["observacao"]),
        ...mapState("company", ["googleAds", "company"]),
        totalItems() {
            if (!this.itemsCart) {
                return "";
            }
            let totalItems = this.itemsCart.totalItems;
            let desc = "";
            if (totalItems == 1) {
                desc = totalItems + " produto no carrinho";
            }
            if (totalItems > 1) {
                desc = totalItems + " produtos no carrinho";
            }
            return desc;
        },
        shipping_company_id() {
            return this.shippingMethod?.shipping_company_id ?? null;
        },
        rule_id() {
            return this.shippingMethod?.rule_id ?? null;
        },
        deliveryTimeValue() {
            return this.deliveryTime
                ? `${this.deliveryTime.date} das ${this.deliveryTime.start_time} às ${this.deliveryTime.end_time}`
                : "";
        },
        showDeliveryTimes() {
            return (
                this.workWithOrder &&
                Permissions.checkModule(Modules.HORARIOS_DE_ENTREGA)
            );
        },
        getBiggerAvailabilityInCart() {
            let biggerAvailability = 0
            this.itemsCart.list.forEach(i => {
                if (i.availability  >  biggerAvailability ) {
                    biggerAvailability = i.availability
                }
            });
            this.biggerAvailability = biggerAvailability
            return +biggerAvailability
        },
        isAddressIncomplete() {
            return !this.mainAddress.postal_code;
        }
    },
};
</script>

<style scoped>
.sub-total-summary,
.total-shipping-summary {
    margin-top: 20px;
    font-weight: 300;
    font-size: 1.9rem;
    display: block;
}
</style>
